// extracted by mini-css-extract-plugin
module.exports = {"error":"Errors_error__3rXEJ"};